import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Intro from '../components/home/intro';
import First from '../components/home/first';
import Interactivo from '../components/home/interactivo';
import Category from '../components/home/category';
import Presentation from '../components/home/presentation';
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Scrollspy from 'react-scrollspy'

export default class PremiumLogin extends React.Component{
  state = {

  }

  componentDidMount(){

  }



  render(){

    var url = "https://animalpolitico.com/acceder?redirect=" + window.location.href;

    return(
      <div id="premiumgateway">
        <div className="page fullpage premiumgateway_c">
          <div className="premiumgateway_c_b">
            <div className="premiumgateway_c_b_logo">
              <img src={require('../static/premium.gif')} />
            </div>
            <div className="premiumgateway_c_b_t">
              Contenido para suscriptores
            </div>
            <div className="premiumgateway_c_b_p">
              Suscríbete o inicia sesión para ver este contenido.
            </div>
            <div className="premiumgateway_c_b_ctas">
              <a href={url} className="premiumgateway_c_b_ctas_c">
                Iniciar sesión
              </a>
              <a href="https://www.animalpolitico.com/suscribete?utm_source=justiciacotidiana"  className="premiumgateway_c_b_ctas_c">
                Suscribirme
              </a>
            </div>

          </div>
        </div>
      </div>
    )
  }
}
